// Credits charged per ASIN for a listing score, mirroring the backend's authoritative
// value (app/subscription/config.py FEATURE_CREDIT_COST.listing_score). Used only to
// warn about insufficient credits before submitting; the backend remains source of truth.
export const LISTING_SCORE_COST_PER_ASIN = 10;
